var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "f3bhvqmiva"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.537255 0 0 0 0 0.545098 0 0 0 0 0.552941 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#f3bhvqmiva)",
    transform: "translate(-580 -1376)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M0 4.751C0 2.125 2.143 0 4.79 0h9.147c1.925 0 3.484 1.546 3.484 3.455 0 1.91-1.56 3.456-3.484 3.456H6.533c-1.202 0-2.178-.968-2.178-2.16 0-1.192.976-2.16 2.178-2.16h6.533V4.32H6.454c-.479 0-.479.864 0 .864h7.483c.958 0 1.742-.777 1.742-1.728 0-.95-.784-1.727-1.742-1.727H4.79c-1.681 0-3.049 1.356-3.049 3.023S3.11 7.775 4.791 7.775h8.275v1.727H4.79C2.143 9.502 0 7.377 0 4.752z",
    transform: "translate(580 1376) rotate(-47 15.5 6.294)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachment-icon.1d70206d0eaa85147479f54302c56ede.svg";
export { ForwardRef as ReactComponent };